<template>
    <div class="public_container add_approval_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="false" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"></ReturnNavBar>
            <div class="mobile_head_operate" >
                <van-popover v-model="headOperatePopoverShow" trigger="click" placement="bottom-end">
                    <ul class="head_operate_popover_list">
                        <li v-for="item in headOperateActionsList" @click="handleClickHeadOperate(item)">
                            <i :class="item.icon"></i> <span v-text="item.text"></span>
                        </li>
                    </ul>
                    <template #reference>
                        <span><i class="iconfont icon-a-tianjiamiaobian"></i></span>
                    </template>
                </van-popover>
            </div>
        </div>
        <div class="warehouse_add_container mobile_container">
            <div class="warehouse_add_wrap">
                <div class="product_list">
                    <ul>
                        <li v-for="(item,index) in formData.productData" :key="index">
                            <i class="iconfont icon-guanbi_dise" @click="handleClickDel(item,index)"></i>
                            <div class="product_field product_border flex_js_wrap">
                                <van-popover :get-container="getContainer" v-model="item.productPopoverShow"  style="left: 0 !important;" :show-arrow="false" :offset="[0,0]" trigger="click" placement="bottom-start">
                                    <div class="productItemBox" v-if="productList.length>0">
                                        <div class="product_item flex_js_wrap" v-for="list in productList" @click="handleClickSelectProduct(item,list)">
                                            <div class="product_name ellipsis">{{ list.name }}</div>
                                            <div class="product_tag" v-if="list.stock_status !='未入库'">入过</div>
                                        </div>
                                    </div>
                                    <template #reference>
                                        <van-field v-model="item.name" @input="handleInputProduct(item)" @blur="handleInputBlurProduct(item)" label="" placeholder="请输入产品名称" ></van-field>
                                    </template>
                                </van-popover>
                                <span>
                                    <span class="field_button" @click="handleClickSelectProductIn(item)">选择</span>
                                </span>

                            </div>
                            <div class="product_field product_border">
                                <van-field @click="handleClickSelectStock(item)" clickable is-link label="" :value="item.stock_name"  name="stock_id" placeholder="请选择入库仓库"  readonly></van-field>
                            </div>
                            <div class="product_field product_border">
                                <van-field v-model="item.unit" label="" :disabled="item.sku_id !='' || (item.code_type && item.code_type == 'encoding_detection' ? true: false)" placeholder="请输入单位"></van-field>
                            </div>
                            <div class="product_field product_border">
                                <van-field v-model="item.cost_price" type="number" label="" :disabled="item.code_type && item.code_type == 'encoding_detection' ? true: false" placeholder="请输入成本价格">
                                    <template #button>
                                        <span>(￥)</span>
                                    </template>
                                </van-field>
                            </div>
                            <div class="product_field ">
                                <div class="bt required">入库数量/产品编码</div>
                                <div class="select_number flex_js_wrap">
                                    <van-field v-model="item.no_code_num" @input="handleInputNoCodeNum(item)" type="digit" label="" placeholder="请输入数量"></van-field>
                                    <div class="select_code_box flex_js_wrap">
                                       <span>
                                            <span class="line"></span>
                                            <span class="select_btn" @click="handleClickSelectCode(item)">选择编码</span>
                                       </span>
                                        <span class="total_num">共{{item.total_num}}</span>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>
                    <div class="product_add">
                        <span @click="handleClickAdd"><i class="el-icon-plus"></i>新增组</span>
                    </div>
                </div>

                <div class="field_item">
                    <div class="field_name">附件</div>
                    <div class="field_content">
                        <div class="file_list" v-if="formData.file_list && formData.file_list.length>0">
                            <ul>
                                <li v-for="(file, file_idx) in formData.file_list" :key="file_idx">
                                    <p class="ellipsis" v-text="file.file_name"></p>
                                    <div>
                                        <span @click="handleClickPreview(file)"><i class="iconfont icon-yanjing"></i></span>
                                        <span @click="formData.file_list.splice(file_idx,1)"><i class="iconfont icon-shanchu1"></i></span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="file_note" v-else>支持.rar .zip .doc .docx .pdf .jpg...</div>
                        <div class="file_upload">
                            <input class="upload_input"  multiple type="file" @change="handleUploadFileChange($event)">
                            <i class="iconfont icon-upload"></i>上传附件
                        </div>

                    </div>
                </div>
                <div class="field_item">
                    <div class="field_name">备注信息</div>
                    <div class="field_content">
                        <van-field
                                v-model="formData.note"
                                rows="3"
                                autosize
                                label=""
                                type="textarea"
                                placeholder="请输入备注信息"
                        />
                    </div>
                </div>

            </div>
        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">提交</van-button>
        </div>
        <SelectStock  :selectStockPopupShow.sync="selectStockPopupShow" v-if="selectStockPopupShow" :selectedStockId="(productInfo && productInfo.stock_id) ? productInfo.stock_id : 0" @success="selectStockSuccess"/>
        <CodeIdentification :codeIdentificationPopupShow.sync="codeIdentificationPopupShow" v-if="codeIdentificationPopupShow" :sourceType="'in'" :productInfo="productInfo" :selectedCodeData="selectedCodeData" @success="selectCodeSuccess" />
        <SelectProductIn :selectProductInPopupShow.sync="selectProductInPopupShow" v-if="selectProductInPopupShow" @success="selectProductSuccess" />

    </div>
</template>

<script>
import {Dialog, ImagePreview} from "vant";
import { searchProducts,addStockIn,codeInGetProduct} from "@/api";
import {getOSSData, uploadImg} from "@/utils/uploadOss";
import {formatFileSize,removeTag} from "@/utils";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import SelectStock from "../component/select_stock"
import CodeIdentification from "../component/code_identification"
import SelectProductIn from "../component/select_product_in"
import {EventBus} from '@/utils/eventBus';
import {mapState} from "vuex";
export default {
    name: "InWarehouseAdd",
    components: {ReturnNavBar,SelectStock,CodeIdentification,SelectProductIn},
    data() {
        return {
            formData:{
                productData:[
                    {
                        name:'',
                        sku_id:'',
                        sku_key:'',
                        stock_id:'',
                        stock_name:'',
                        unit:'',
                        cost_price:'',
                        no_code_num:0, //输入的无编码数量
                        code_num:0, //选择的有编码数量
                        code_list:[], //选择的编码
                        total_num:0, //选择的总数量
                        not_found_code:[], // 不存在的编码
                        unmatched_code:[],//已存在未绑定的编码
                    }
                ],
                file_list:[],
                note:''
            },
            btnDisabled:false,
            headOperatePopoverShow: false,
            headOperateActionsList: [
                {value:"codeIdentification", text: "粘贴编码识别", icon: "iconfont icon-chuku" },
                {value:"scan", text: "扫码入库", icon: "iconfont icon-saoyisao" },
                {value:"batch_stock", text: "批量选择仓库", icon: "iconfont icon-piliangcaozuo" },
            ],
            value:'',
            productPopoverShow:false,
            productList:[],
            selectStockPopupShow:false,
            productInfo:null,
            codeIdentificationPopupShow:false,
            selectedCodeData:[],//已选编码
            selectProductInPopupShow:false,
            project_manage_id:'',
        };
    },
    computed: {
        ...mapState(['inventoryProductData']),
    },
    activated() {
        // 组件被激活
        if(this.inventoryProductData && this.inventoryProductData.length){
            this.setInventoryProductData(this.inventoryProductData)
        }
    },
    created() {
        if(this.$route.query.project_manage_id){
            this.project_manage_id = this.$route.query.project_manage_id
        }
        this.getSearchProducts({name:''})
    },
    methods: {
        setInventoryProductData(data){
            if(data && data.length){
                this.formData.productData = []
                data.forEach((item)=>{
                    let json = {
                        name:item.name,
                        sku_id:item.sku_id,
                        sku_key:item.sku_key,
                        stock_id:item.stock_id,
                        stock_name:item.stock_id ? item.stocks?.name : '',
                        unit:item.unit,
                        cost_price:'',
                        no_code_num:0, //输入的无编码数量
                        code_num:0, //选择的有编码数量
                        code_list:[], //选择的编码
                        total_num:0, //选择的总数量
                        not_found_code:[], // 不存在的编码
                        unmatched_code:[],//已存在未绑定的编码
                    }
                    this.formData.productData.push(json)
                })
                this.$store.dispatch("inventoryProductData", []);
            }
        },

        getContainer() {
           return  document.querySelector('.warehouse_add_container')
        },
        // 搜索产品
        getSearchProducts(item){
            searchProducts({
                keyword:item.name
            }).then(res => {
                if (res.code === 200) {
                    this.productList = res.data ? res.data : []
                    let info = this.productList.find(find =>find.name == item.name)
                    if(item.name){
                        this.$set(item,'productPopoverShow',true)
                    }
                    if(info){
                        this.$set(item,'sku_id',info.sku_id)
                        this.$set(item,'sku_key',info.sku_key)
                        this.$set(item,'unit',info.unit)
                    }else{
                        this.$set(item,'sku_id','')
                        this.$set(item,'sku_key','')
                        this.$set(item,'unit','')
                    }
                    this.clearInfoData(item)

                }
            })
        },
        // 输入时
        handleInputProduct(item){
            this.getSearchProducts(item)
        },
        // 失去焦点
        handleInputBlurProduct(item){

        },
        // 选中产品
        handleClickSelectProduct(item,list){
            this.$set(item,'name',list.name)
            this.$set(item,'sku_id',list.sku_id)
            this.$set(item,'sku_key',list.sku_key)
            this.$set(item,'unit',list.unit)
            this.$set(item,'productPopoverShow',false)
            this.clearInfoData(item)
        },
        // 选择产品
        handleClickSelectProductIn(item){
            this.productInfo = item
            this.selectProductInPopupShow = true
        },
        // 选择产品回调
        selectProductSuccess(data){

            if(data && data.length>0){
                data.forEach((item,key) =>{
                    if(key == 0){
                        // 选择的那个
                        this.$set(this.productInfo,'name',item.name)
                        this.$set(this.productInfo,'sku_id',item.sku_id)
                        this.$set(this.productInfo,'sku_key',item.sku_key)
                        this.$set(this.productInfo,'unit',item.unit)
                        this.clearInfoData() // 清空数据
                    }else{
                        let json = {
                            name:item.name,
                            sku_id:item.sku_id,
                            sku_key:item.sku_key,
                            stock_id:'',
                            stock_name:'',
                            unit:item.unit,
                            cost_price:'',
                            no_code_num:0, //输入的无编码数量
                            code_num:0, //选择的有编码数量
                            code_list:[], //选择的编码
                            total_num:0, //选择的总数量
                            not_found_code:[], // 不存在的编码
                            unmatched_code:[],//已存在未绑定的编码
                        }
                        this.formData.productData.push(json)

                    }
                })
            }
        },
        // 清空数据
        clearInfoData(item){
            this.$set(this.productInfo ? this.productInfo :item,'code_list',[])
            this.$set(this.productInfo ? this.productInfo :item,'not_found_code',[])
            this.$set(this.productInfo ? this.productInfo :item,'unmatched_code',[])
            this.$set(this.productInfo ? this.productInfo :item,'code_num',0)
            this.$set(this.productInfo ? this.productInfo :item,'no_code_num',0)
            this.$set(this.productInfo ? this.productInfo :item,'total_num',0)
            this.$set(this.productInfo ? this.productInfo :item,'cost_price','')
            this.$set(this.productInfo ? this.productInfo :item,'code_type','')
        },
        // 头部+号操作
        handleClickHeadOperate(item){
            this.headOperatePopoverShow = false
            if(item.value == 'codeIdentification'){  //编码识别
                this.productInfo = null
                this.selectedCodeData = []
                this.formData.productData.forEach(item =>{
                    this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
                })
                this.codeIdentificationPopupShow = true
            }else if(item.value == 'batch_stock'){
                this.productInfo = null
                this.selectStockPopupShow = true
            }
        },
        // 选择产品编码
        handleClickSelectCode(item){
            if(item.name == '')return this.$toast('请先选择产品')
            this.productInfo = item
            this.selectedCodeData = []
            this.formData.productData.forEach(item =>{
                this.selectedCodeData = this.selectedCodeData.concat(item.code_list)
            })
            this.codeIdentificationPopupShow = true
        },
        // 选择编码后回调
        selectCodeSuccess(data){
            let code_type = data.type  // 'encoding_detection' ==  代表已绑定产品识别码 ；  'manual_entry_binding' == 代表未绑定产品识别码
            if(this.productInfo && this.productInfo.name){
                let {code_list, selected_code_list, not_found_code, unmatched_code} = data
                if(code_type == 'encoding_detection'){
                    this.encodingDetectionFunction(data,code_type)
                }else{
                    this.$set(this.productInfo,'code_list',selected_code_list.concat(code_list)) //已选的+ 新增的
                    this.$set(this.productInfo,'not_found_code',this.productInfo.not_found_code.concat(not_found_code)) //不存在的
                    this.$set(this.productInfo,'unmatched_code',this.productInfo.unmatched_code.concat(unmatched_code)) //存在没绑定
                    this.$set(this.productInfo,'code_num',this.productInfo.code_list.length)
                    this.$set(this.productInfo,'total_num',Number(this.productInfo.no_code_num) + Number(this.productInfo.code_num))
                    this.$set(this.productInfo,'code_type',this.productInfo.code_type == 'encoding_detection' ? 'encoding_detection' : code_type)
                }
                this.productInfo = null
            }else{
                // 编码识别
                this.encodingDetectionFunction(data,code_type)
            }
        },
        encodingDetectionFunction(dataInfo,code_type){
            this.loading = true
            let code_list = []
            if(this.formData.productData.length == 1){
                if(!this.formData.productData[0].stock_id && !this.formData.productData[0].name && !this.formData.productData[0].cost_price && !this.formData.productData[0].total_num && !this.formData.productData[0].unit) {
                    this.formData.productData.splice(0,1)
                }
            }
            this.formData.productData.forEach((item, key) => {
                let code = item.code_list.map(map => map.code)
                code_list = [...code_list, ...code]
            })
            let codeList = dataInfo.code_list.filter(item => !code_list.includes(item));
            if(codeList.length != dataInfo.code_list.length){
                this.$toast('检查到有重复的编码已经为您去重')
            }
            if(codeList.length == 0){ this.loading = false; return  false }

            codeInGetProduct({code_list:codeList}).then(res => {
                if (res.code === 200) {
                    let {data} = res
                    data.forEach((item,key)=>{
                        this.mergeProductFunction(item,code_type)
                    })
                }
                this.loading = false
            })
        },
        // 合并产品
        mergeProductFunction(row,code_type){
            let flag = true
            if(this.formData.productData.length>0){
                this.formData.productData.forEach((item, index) => {
                    if(item.name == row.name && item.sku_id == row.sku_id && item.sku_key == row.sku_key && item.cost_price == row.cost_price && item.unit == row.unit){
                        let code_list = row.code_list.map((map)=>{return {code:map}})
                        this.$set(item,'cost_price',row.cost_price)
                        this.$set(item,'code_list',item.code_list.concat(code_list))
                        this.$set(item,'code_num',item.code_list.length)
                        this.$set(item,'total_num',Number(item.code_num) + Number(item.no_code_num))
                        this.$set(item,'code_type',item.code_type == 'encoding_detection' ? 'encoding_detection' : code_type)
                        flag = false
                    }
                })
            }
            if(flag){
                let json = {
                    name:row.name,
                    stock_id:row.stock_id,
                    sku_id:row.sku_id,
                    sku_key:row.sku_key,
                    unit:row.unit,
                    cost_price:row.cost_price,
                    code_num:row.code_num, //选择的编码数量
                    code_list:row.code_list, //选择的编码
                    no_code_num:row.no_code_num, //选择的编码数量
                    total_num:row.total_num, //选择的总数量
                    not_found_code:[], // 不存在的编码
                    unmatched_code:[],//已存在未绑定的编码
                    code_type:code_type
                }
                this.formData.productData.push(json)
            }

        },
        // 输入无编码数量
        handleInputNoCodeNum(item){
            this.$nextTick(()=>{
                this.$set(item,'total_num',Number(item.no_code_num) + Number(item.code_num))
            })
        },
        // 选择仓库
        handleClickSelectStock(item){
            this.productInfo = item
            this.selectStockPopupShow = true
        },
        // 选择仓库后回调
        selectStockSuccess(data){
            if(this.productInfo){
                this.$set(this.productInfo,'stock_id',data.id)
                this.$set(this.productInfo,'stock_name',data.name)
            }else{
                this.formData.productData.forEach(item =>{
                    this.$set(item,'stock_id',data.id)
                    this.$set(item,'stock_name',data.name)
                })
            }
            this.productInfo = null
        },
        // 删除
        handleClickDel(item,index){
            if(this.formData.productData.length == 1) return this.$toast('当前数据行不可删除，最少保留一行')
            this.formData.productData.splice(index,1)
        },
        // 新增行
        handleClickAdd(){
            let json = {
                name:'',
                sku_id:'',
                sku_key:'',
                stock_id:'',
                stock_name:'',
                unit:'',
                cost_price:'',
                no_code_num:0, //输入的无编码数量
                code_num:0, //选择的有编码数量
                code_list:[], //选择的编码
                total_num:0, //选择的总数量
                not_found_code:[], // 不存在的编码
                unmatched_code:[],//已存在未绑定的编码
            }
            this.formData.productData.push(json)
        },
        // 上传附件
        handleUploadFileChange(e){
            const files = e.target.files
            console.log(files);
            const that = this;
            Array.from(files).forEach(file => {
                uploadImg(file, 50).then(res => {
                    if (res.file_path) {
                        res.file_size = formatFileSize(file.size)
                        this.formData.file_list.push(res)
                        e.target.value = ''
                    }
                    e.target.value = ''
                }).catch(error => {
                    e.target.value = ''
                })
            })
        },
        // 预览
        handleClickPreview(file){
            if (file.file_type && file.file_type.indexOf("image") > -1) {
                ImagePreview({
                    images: [file.file_path],
                    startPosition: 0,
                });
            } else {
                if (file.file_type && file.file_type.indexOf("pdf") > -1) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        handleClickReturnRouter(){
            if (this.formData.note || this.formData.file_list.length > 0 || (this.formData.productData.length > 0 && this.formData.productData.filter(item => (item.name || item.stock_id || item.cost_price || item.total_num || item.unit)).length>0 )){
                Dialog.confirm({
                    title: "取消",
                    message: "取消后，编辑内容不保留，是否取消！",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                })
                .then(() => {
                    removeTag(this.$route)
                    this.$router.go(-1);
                })
                .catch(() => { });
            }else{
                removeTag(this.$route)
                this.$router.go(-1);
            }
        },
        handleClickConfirm() {
            let flag = false
            let productData = JSON.parse(JSON.stringify(this.formData.productData))
            if(productData.length == 0){
                return  this.$toast(`至少入库一个产品`)
            }
            productData.forEach((item,index) => {
                if(!item.name && !flag){
                    this.$toast(`请选择第${index+1}个产品`)
                    flag = true
                }
                if(!item.stock_id && !flag){
                    this.$toast(`请选择${item.name}仓库`)
                    flag = true
                }
                if(!item.total_num && !flag){
                    this.$toast(`请输入${item.name}入库数量`)
                    flag = true
                }
                delete  item.productPopoverShow
                delete  item.stock_name
            })
            if(flag){return  false}
            let postData = {
                stock_type:'general', //出入库类型（普通）
                product_list:productData,
                files:this.formData.file_list,
                note:this.formData.note,
            }
            if(this.project_manage_id){
                postData.related_type = 'project_manage'  //业务类型 （项目）
                postData.related_id = this.project_manage_id
            }

            Dialog.confirm({
                title: "提交入库",
                message: "确定执行入库操作吗？ \r\n 提交后无法撤回，请谨慎操作。",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
            })
            .then(() => {
                this.btnDisabled = true
                addStockIn(postData).then(res => {
                    if (res.code === 200) {
                        this.$toast({
                            message: "入库成功",
                            type: "success",
                            duration: 1500,
                            onClose: () => {
                                removeTag(this.$route)
                                EventBus.$emit('inventoryInUpdated');
                                this.$router.go(-1);
                                this.btnDisabled = false
                            }
                        })
                    }else{
                        this.btnDisabled = false
                    }
                })
            })
            .catch(() => { });

        },

    },
};
</script>

<style lang="scss" scoped>
.warehouse_add_container{
    width: 100%;
    padding: 10px 0;
    box-sizing: border-box;
    .warehouse_add_wrap{
        background: #fff;
        .product_list{
            width: 100%;
            padding: 12px 16px;
            box-sizing: border-box;
            ul{
                li{
                    width: 100%;
                    margin-bottom: 10px;
                    border-radius: 6px;
                    background: rgba(247, 248, 250, 1);
                    position: relative;
                    .icon-guanbi_dise{
                        position: absolute;
                        right: -6px;
                        top: -6px;
                        font-size: 16px;
                        color: rgba(191, 191, 191, 1);
                    }
                    .product_field{
                        width: 100%;
                        padding: 0 12px;
                        .van-popover__wrapper{
                            flex: 1;
                            display: block;
                        }
                        &.product_border{
                            position: relative;
                            &:before{
                                position: absolute;
                                width: calc(100% - 24px);
                                height: 1px;
                                background: rgba(232, 232, 232, 1);
                                content: " ";
                                left: 12px;
                                bottom: 0;
                                z-index: 9;
                            }
                        }
                        .van-cell{
                            padding-left: 0;
                            padding-right: 0;
                            background: rgba(247, 248, 250, 1);
                        }
                        .field_button{
                            font-size: 14px;
                            padding-left: 8px;
                            color: rgba(41, 144, 255, 1);
                            line-height: 14px;
                            border-left: 1px solid rgba(232, 232, 232, 1);
                        }

                        .bt{
                            padding-top: 10px;
                            line-height: 22px;
                            font-size: 14px;
                            color: rgba(51, 51, 51, 1);
                            &.required{
                                position: relative;
                                padding-left: 6px;
                                &:before{
                                    position: absolute;
                                    left: 0;
                                    top: 10px;
                                    content: "*";
                                    color: rgba(228, 65, 68, 1);
                                }
                            }
                        }
                        .select_number{
                            width: 100%;
                            .van-cell{
                                width: 78px;
                            }
                            .select_code_box{
                                flex: 1;
                                line-height: 24px;
                                position: relative;
                                .select_btn{
                                    font-size: 14px;
                                    color: rgba(41, 144, 255, 1);
                                }
                                .total_num{
                                    border-radius: 4px;
                                    background: rgba(255, 255, 255, 1);
                                    min-width: 22px;
                                    padding: 0 4px;
                                    line-height: 22px;
                                    font-size: 14px;
                                    color: rgba(153, 153, 153, 1);
                                }
                            }
                        }

                    }
                }
            }
            .product_add{
                text-align: center;
                line-height: 22px;
                span{
                    color: rgba(25, 144, 255, 1);
                    i{
                        font-size: 14px;
                        margin-right: 8px;
                    }
                }
            }
        }

        .field_item{
            width: 100%;
            border-top: 1px solid rgba(247, 248, 250, 1);
            padding: 10px 16px;
            box-sizing: border-box;

            .field_name{
                width: 100%;
                line-height: 22px;
                font-size: 14px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 4px;
            }
            .field_content{
                width: 100%;
                .van-cell{
                    padding:0 0 4px 0;
                }
                ::v-deep .van-cell--required::before{
                    position: initial;
                    margin-right: 2px;
                }
                .file_list{
                    width: 100%;
                    ul{
                        width: 100%;
                        li{
                            width: 100%;
                            margin-bottom: 10px;
                            border-radius: 2px;
                            background: rgba(249, 249, 249, 1);
                            border: 1px solid rgba(217, 217, 217, 1);
                            line-height: 20px;
                            padding: 0 8px;
                            box-sizing: border-box;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                width: calc(100% - 50px);
                                font-size: 12px;
                                color: rgba(102, 102, 102, 1);
                            }
                            div{
                                width: 48px;
                                span{
                                    width: 16px;
                                    margin-left: 8px;
                                    text-align: center;
                                    line-height: 16px;
                                }
                                i{
                                    font-size: 14px;
                                    color: rgba(102, 102, 102, 1);
                                }
                            }
                        }
                    }
                }
                .file_note{
                    font-size: 12px;
                    color: rgba(153, 153, 153, 1);
                    line-height: 18px;
                    margin-bottom: 34px;
                }
                .file_upload{
                    width: 100px;
                    position: relative;
                    line-height: 22px;
                    margin: 0 auto;
                    color: rgba(25, 144, 255, 1);
                    font-size: 14px;
                    text-align: center;
                    i{
                        margin-right: 8px;
                    }
                    input{
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        opacity: 0;
                    }
                }

            }
        }
    }
}

.add_footer_wrap {
    padding: 5px 16px;
    background-color: #f7f8fa;

    .van-button {
        border-radius: 8px;
        height: 38px;
        background-color: rgba(41, 144, 240, 1);
        border-color: rgba(41, 144, 240, 1);
    }
}

    ::v-deep .van-popover[data-popper-placement="bottom-start"] .van-popover__arrow{
        display: none !important;
    }

    .productItemBox{
        width: calc(100vw - 56px);
        padding: 8px 2px;
        box-sizing: border-box;
        max-height: 220px;
        overflow-y: auto;
        .product_item{
            width: 100%;
            line-height: 30px;
            padding: 0 12px;
            color: rgba(102, 102, 102, 1);
            &:active{
                color: rgba(102, 102, 102, 1);
                background: rgba(0, 0, 0, 0.04);
            }
            .product_name {
                display: block;
                width: calc(100% - 50px);
            }
            .product_tag {
                width: 40px;
                height: 22px;
                opacity: 1;
                border-radius: 4px;
                background: rgba(240, 170, 50, 0.1);
                line-height: 22px;
                font-size: 12px;
                color: rgba(240, 170, 50, 1);
                text-align: center;
            }
        }

    }
</style>
